import { HttpInterceptorFn } from '@angular/common/http';
import { retryWithBackoff } from '@pharvio/core/shared';

const SAFE_METHODS = ['GET', 'HEAD', 'OPTIONS'];

/**
 * Retries transient HTTP errors (0/408/429/503) on safe methods only.
 * Mutations (POST/PUT/PATCH/DELETE) are never retried — they may not be idempotent.
 */
export const retryInterceptor: HttpInterceptorFn = (req, next) => {
  if (!SAFE_METHODS.includes(req.method)) {
    return next(req);
  }

  return next(req).pipe(
    retryWithBackoff({
      retryAfter: 500,
      maxRetry: 2,
      delayAfterRetry: 500
    })
  );
};
